import { useDispatch, useSelector } from 'react-redux';
import { cn } from '@distribute/frontend/utils';
import { EditorSidebarButton } from '../../../../../shared/ui';
import { FC, useEffect } from 'react';
import { sidebarOptions } from './lib/config';
import { LEFT_SIDEBAR_ID } from '../../../../../features/editor-left-sidebar/config';
import { editorLeftSidebarModel } from '../../../../../features/editor-left-sidebar';
import { SnippetEditorLeftSidebarContent } from './SnippetEditorLeftSidebarContent';

export const SnippetEditorLeftSidebar: FC = () => {
  const dispatch = useDispatch();

  const selectedOption = useSelector(
    editorLeftSidebarModel.selectors.selectSidebarOption
  );

  useEffect(() => {
    return () => {
      dispatch(editorLeftSidebarModel.actions.setSelectedOption(null));
    };
  }, [dispatch]);

  return (
    <div
      className={cn('h-[calc(100vh-68px)]', {
        'rounded-2xl bg-base-white flex': !!selectedOption,
      })}
      id={LEFT_SIDEBAR_ID}
    >
      <div className="flex flex-col items-center justify-between h-full pb-4 overflow-y-auto min-w-20">
        <div className="flex flex-col gap-2 px-2 pt-2 pb-4">
          {sidebarOptions.map((option) => (
            <EditorSidebarButton
              key={option.id}
              title={option.name}
              isSelected={option.id === selectedOption}
              icon={option.icon}
              onClick={() => {
                dispatch(
                  editorLeftSidebarModel.actions.setSelectedOption(
                    selectedOption === option.id ? null : option.id
                  )
                );
              }}
            />
          ))}
        </div>
      </div>

      {!!selectedOption && <SnippetEditorLeftSidebarContent />}
    </div>
  );
};
